<div
  style="background-image: url('assets/sign-up-bg.svg')"
  class="seller-signup h-screen overflow-y-auto bg-[#BBDEEB] bg-cover bg-no-repeat bg-center"
>
  <div class="container mx-auto flex justify-center px-17.5 pt-12 relative">
    <sham-i-sham-logo-Full class="px-2 absolute top-4 xl:start-17.5 start-12" />

    <div
      class="max-w-[717px] xl:w-[717px] py-8 px-40 pb-10.5 rounded bg-white-light space-y-4"
    >
      <h2 class="font-semibold text-[32px] leading-[36px] p-2.5 text-center mb-2">
        Create New Password
      </h2>

      <p class="text-center text-sm text-[#6D6D6D] mb-4">
        Enter your new password below.
      </p>

      <section class="space-y-4">
        @if (!submitSuccess()) {
          <dx-form [formData]="formData()" [colCount]="1" [labelLocation]="'top'">
            <dxi-item
              dataField="password"
              [label]="{ text: 'New Password' }"
              [editorOptions]="passwordEditorOptions"
              [validationRules]="[
                { type: 'required', message: 'Password is required' },
                {
                  type: 'pattern',
                  pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
                  message:
                    'Password must be at least 8 characters and include letters and numbers',
                },
              ]"
            />

            <dxi-item
              dataField="confirmPassword"
              [label]="{ text: 'Confirm Password' }"
              [editorOptions]="confirmPasswordEditorOptions"
              [validationRules]="[
                { type: 'required', message: 'Confirm password is required' },
                {
                  type: 'compare',
                  comparisonTarget: passwordComparisonTarget,
                  message: 'Passwords do not match',
                },
              ]"
            />
          </dx-form>

          @if (submitError()) {
            <p class="text-sm text-red-600 text-center">
              {{ submitError() }}
            </p>
          }

          <dx-button
            text="Reset Password"
            type="default"
            stylingMode="contained"
            [width]="'100%'"
            [disabled]="loading()"
            (onClick)="onSubmit()"
          />
        } @else {
          <div class="text-center space-y-4">
            <p class="text-[#178EB4] font-semibold">Password reset successfully</p>

            <p class="text-sm text-[#6D6D6D]">
              You can now login using your new password.
            </p>

            <a routerLink="/login" class="text-blue font-semibold"> Go to Login </a>
          </div>
        }
      </section>
    </div>
  </div>

  <div class="page-footer-copy text-center text-[#6D6D6D] mt-5">
    All rights reserved © Shamsuperstore.com
  </div>
</div>
